import { Injectable } from '@angular/core';

import { IParticipantGroupBySettings, IRatingIcon } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class ParticipantsByTypeWidgetService {
    generateRatingIcons(min: number, max: number, average: number): IRatingIcon[] {
        // TODO: Support half starts
        const ratingIcons: IRatingIcon[] = [];
        for (let i = min; i <= max; i++) {
            let isFull = false;
            let isEmpty = false;
            const isHalf = false;
            if (i <= average) {
                isFull = true;
            } else {
                isEmpty = true;
            }
            ratingIcons.push({
                isFull: isFull, isHalf: isHalf, isEmpty: isEmpty
            });
        }
        return ratingIcons;
    }

    areSettingsValid(settings: IParticipantGroupBySettings): boolean {
        if (!settings.remote) {
            return false;
        }
        if (!settings.remote.field_name) {
            return false;
        }
        if (!settings.remote.participant_filter) {
            return false;
        }
        if (!settings.remote.event_id) {
            return false;
        }
        return true;
    }
}
